import React, {Component} from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Button
} from 'reactstrap'
import moment from "moment";

const newRecord = require('../store/newRecord')
const R = require('ramda')

class TardySweep extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stuID: '',
      student: '',
      studentList: [],
      studentIdList: [],
      contact: props.user.name,
      addedConfirmation: false
    }
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitNoId = this.onSubmitNoId.bind(this);
    this.onSatSchool = this.onSatSchool.bind(this);
  }

  componentDidMount() {
    let _this = this;
    this.props.db.ref('students').once('value', snap => {
      let studentList = R.values(snap.val());
      studentList = R.map(s => R.pick(['lastName','firstName','stuID','classOf'], s), studentList);
      let studentIdList = R.map(s => s.stuID, studentList);
      studentList = R.sort((a,b) => (a.lastName+' '+a.firstName < b.lastName+' '+b.firstName) ? -1 : 1, studentList)
      _this.setState({studentList, studentIdList})
    })
  }

  onSubmit(evt, ignore=false) {
    let _this = this;
    evt.preventDefault();
    let sid = (this.state.student.length > 0) ? this.state.student : this.state.stuID;
    let rec = newRecord();
    rec.stuID = sid;
    rec.dateOn = moment().unix();
    rec.contact = this.state.contact;
    rec.owner = this.props.user.lastName+this.props.user.firstName;
    rec.reason = R.find(it => it.reason === 'Tardy sweep', this.props.reasons).idx;
    rec = R.omit(['key'], rec);
    this.props.db.ref('records/'+sid).push(rec);
    if (!ignore) {
      let stu = this.props.studentObjs[sid]
      _this.props.db.ref('students/' + sid + '/lopCount').set(stu.lopCount + 1)
    }
    this.setState({
      stuID: '',
      student: '',
      addedConfirmation: true
    })
    setTimeout(() => {
      _this.setState({addedConfirmation: false})
    }, 3000);
  }

  onSubmitNoId(evt) {
    evt.preventDefault();
    let sid = (this.state.student.length > 0) ? this.state.student : this.state.stuID;
    let rec = newRecord();
    rec.stuID = sid;
    rec.dateOn = moment().unix();
    rec.contact = this.state.contact;
    rec.owner = this.props.user.lastName+this.props.user.firstName;
    rec.reason = R.find(it => it.reason === 'No ID', this.props.reasons).idx;
    rec = R.omit(['key'], rec);
    this.props.db.ref('records/'+sid).push(rec);
    let stu = this.props.studentObjs[sid]
    this.props.db.ref('students/'+sid+'/lopCount').set(stu.lopCount+2)
    this.onSubmit(evt, true);
  }

  onSatSchool(evt) {
    evt.preventDefault();
    let _this = this;
    let sid = (this.state.student.length > 0) ? this.state.student : this.state.stuID;
    let rec = newRecord();
    rec.stuID = sid;
    rec.dateOn = moment().unix();
    rec.contact = this.state.contact;
    rec.owner = this.props.user.lastName+this.props.user.firstName;
    rec.reason = R.find(it => it.reason === 'Saturday school', this.props.reasons).idx;
    rec = R.omit(['key'], rec);
    this.props.db.ref('records/'+sid).push(rec);
    this.setState({
      stuID: '',
      student: '',
      addedConfirmation: true
    })
    setTimeout(() => {
      _this.setState({addedConfirmation: false})
    }, 3000);
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name');
    this.setState(R.assoc(field, evt.currentTarget.value, {}))
  }

  render() {
    let isValid = this.state.contact.length > 0 && ((this.state.stuID.length > 0 && R.includes(this.state.stuID, this.state.studentIdList)) || this.state.student.length > 0);
    let invalidStuId = this.state.student.length === 0 && !R.includes(this.state.stuID, this.state.studentIdList)
    return (
      <div>
        <Row className="master-detail-top-separator">
          <Col md={6}>
            <Form onSubmit={this.onSubmit}>
              <FormGroup row>
                <Label for="stuID" md={6}>Enter a student ID...</Label>
                <Col md={6}>
                  <Input type="text"
                         autoFocus
                         name="stuID"
                         id="stuID"
                         invalid={this.state.stuID.length > 0 && invalidStuId}
                         disabled={this.state.student.length > 0}
                         value={this.state.stuID}
                         onChange={this.onChange}
                         placeholder="Student ID" />
                  <FormFeedback>This student ID is invalid</FormFeedback>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="stuID" md={6}>...or select a student:</Label>
                <Col md={6}>
                  <Input type="select"
                         name="student"
                         id="student"
                         onChange={this.onChange}
                         value={this.state.student}>
                    {
                      R.prepend(<option key="none" value=''>-- Select --</option>, this.state.studentList.map(s => <option key={s.stuID} value={s.stuID}>{s.lastName}, {s.firstName} ({s.classOf})</option>))
                    }
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="contact" md={6}>Contact person</Label>
                <Col md={6}>
                  <Input type="text"
                         name="contact"
                         id="contact"
                         onChange={this.onChange}
                         placeholder="Contact person"
                         value={this.state.contact} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col md={4}>
                  <Button type="button"
                          disabled={!isValid}
                          onClick={this.onSatSchool}
                          color="primary">Add Sat School</Button>
                </Col>
                <Col md={5} className="text-right">
                  <Button type="button"
                          disabled={!isValid}
                          onClick={this.onSubmitNoId}
                          color="primary">Add tardy & no ID</Button>
                </Col>
                <Col md={3} className="text-right">
                  <Button type="submit"
                          disabled={!isValid}
                          color="primary">Add tardy</Button>
                </Col>
              </FormGroup>
            </Form>
            {
              (this.state.addedConfirmation) ?
                <Row>
                  <Col md={6}>{' '}</Col>
                  <Col md={6}><h4 className="text-center">Record added</h4></Col>
                </Row> : null
            }
          </Col>
        </Row>
      </div>
    )
  }
}

export default TardySweep



// WEBPACK FOOTER //
// ./src/views/TardySweep.js